const users = 'users';
const settings = 'helm-settings';

export default {
  users,
  settings,
};
